const buildUrl = require('build-url')

const Logout = {
    LOGOUT_URL: 'https://login.itb.ac.id/cas/logout',
    CALLBACK_URL: '/logout',
    getParamFromCurrentUrl: param => {
        return new URL(window.location.href).searchParams.get(param)
    },
    getBaseUrl: () => {
        return window.location.protocol + "//" + window.location.host
    },
    getLogoutUrl: () => {
        const PARAM = {
            service: buildUrl(Logout.getBaseUrl() + Logout.CALLBACK_URL, {queryParams: {logout: true}})
        }

        return buildUrl(Logout.LOGOUT_URL, {
            queryParams: PARAM
        })
    }
}

export default Logout;